/** @format */
import { RefObject, useEffect } from 'react';

/**
 * This hook is used to listen to focus events within the dom element its attached to
 */
export const useFocusWithin = (
    ref: RefObject<HTMLElement>,
    handler: (event: Event) => void
) => {
    const focusHandler = (event: FocusEvent) => {
        handler(event);
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
        ref.current &&
            ref.current.addEventListener('focus', focusHandler, true);

        return () => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
            ref.current &&
                // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
                ref.current.removeEventListener('focus', focusHandler, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [ref.current, handler]);
};
